(function(){
'use strict';
var STORAGE_KEY='mm_wishlist';
var COUNT_KEY='mm_wl_counts';

function getCounts(){try{return JSON.parse(localStorage.getItem(COUNT_KEY)||'{}');}catch(_){return{};}}
function saveCounts(c){try{localStorage.setItem(COUNT_KEY,JSON.stringify(c));}catch(_){}}
function seedCount(handle){
  var n=0;
  for(var i=0;i<handle.length;i++)n=(n*31+handle.charCodeAt(i))&0xffff;
  return 12+Math.floor((n%78));
}
function getCount(handle){
  var counts=getCounts();
  if(counts[handle]===undefined){counts[handle]=seedCount(handle);saveCounts(counts);}
  return counts[handle];
}
function incrementCount(handle){
  var counts=getCounts();
  if(counts[handle]===undefined)counts[handle]=seedCount(handle);
  counts[handle]++;
  saveCounts(counts);
  return counts[handle];
}
function decrementCount(handle){
  var counts=getCounts();
  if(counts[handle]===undefined)counts[handle]=seedCount(handle);
  counts[handle]=Math.max(0,counts[handle]-1);
  saveCounts(counts);
  return counts[handle];
}

function getList(){try{return JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');}catch(_){return[];}}
function saveList(list){localStorage.setItem(STORAGE_KEY,JSON.stringify(list));updateHeaderCount();}

function toggle(handle){
  var list=getList();
  var idx=list.indexOf(handle);
  var action;
  if(idx===-1){
    list.push(handle);
    incrementCount(handle);
    action='add';
  }else{
    list.splice(idx,1);
    decrementCount(handle);
    action='remove';
  }
  saveList(list);
  if(window.WishlistAnalytics){
    window.WishlistAnalytics.track(action, handle);
  }
  return list.includes(handle);
}

function isWishlisted(handle){return getList().includes(handle);}

function updateHeaderCount(){
  var count=getList().length;
  document.querySelectorAll('.wl-header-count').forEach(function(el){
    el.textContent=count;
    el.classList.toggle('is-visible',count>0);
  });
}

function syncBtn(btn){
  var handle=btn.dataset.handle;
  if(!handle)return;
  var w=isWishlisted(handle);
  btn.classList.toggle('is-wishlisted',w);
  var label=w?'Wishlisted':'Add to Wishlist';
  var t=btn.querySelector('.wl-btn-text');
  if(t)t.textContent=label;
  btn.setAttribute('aria-label',label);
}

function syncCardBadge(handle){
  document.querySelectorAll('product-card[handle="'+handle+'"]').forEach(function(card){
    var badge=card.querySelector('.wl-count-badge');
    var count=getCount(handle);
    if(!badge){
      var figure=card.querySelector('.product-card__figure');
      if(!figure)return;
      badge=document.createElement('div');
      badge.className='wl-count-badge';
      figure.appendChild(badge);
    }
    badge.innerHTML='<svg viewBox="0 0 24 24" fill="'+(isWishlisted(handle)?'#e03d2f':'currentColor')+'" width="9" height="9"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> '+count;
    badge.classList.toggle('wl-count-badge--active', isWishlisted(handle));
  });
}

function syncAllBadges(){
  document.querySelectorAll('product-card[handle]').forEach(function(card){
    syncCardBadge(card.getAttribute('handle'));
  });
}

function syncAllButtons(){
  document.querySelectorAll('[data-wl-btn]').forEach(syncBtn);
}

function handleClick(e){
  var btn=e.target.closest('[data-wl-btn]');
  if(!btn)return;
  e.preventDefault(); e.stopPropagation();
  var handle=btn.dataset.handle;
  if(!handle)return;
  toggle(handle);
  document.querySelectorAll('[data-wl-btn][data-handle="'+handle+'"]').forEach(syncBtn);
  syncCardBadge(handle);
  btn.classList.add('wl-pop');
  btn.addEventListener('animationend',function(){btn.classList.remove('wl-pop');},{once:true});
  if(window.WishlistDrawer)WishlistDrawer.render();
}
document.addEventListener('click',handleClick);

function addToCart(variantId,btn){
  var orig=btn.textContent;
  btn.textContent='Adding…'; btn.disabled=true;
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:variantId,quantity:1})})
    .then(function(r){return r.json();})
    .then(function(){
      btn.textContent='Added ✓'; btn.style.background='#22c55e';
      setTimeout(function(){btn.textContent=orig;btn.style.background='';btn.disabled=false;},2000);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function(){btn.textContent='Error';btn.disabled=false;});
}

function getImgSrc(val){
  if(!val)return '';
  if(typeof val==='string')return val;
  if(val.src)return val.src;
  if(val.url)return val.url;
  return '';
}

function fetchAllRecs(productIds){
  if(!productIds||!productIds.length)return Promise.resolve([]);
  var id=productIds[0];
  return fetch('/recommendations/products.json?product_id='+id+'&limit=10&intent=complementary')
    .then(function(r){return r.ok?r.json():null;})
    .then(function(data){
      if(data&&data.products&&data.products.length>0)return data.products;
      return fetch('/recommendations/products.json?product_id='+id+'&limit=10')
        .then(function(r){return r.ok?r.json():null;})
        .then(function(d){return d&&d.products?d.products:[];});
    })
    .then(function(recs){
      var handles=getList();
      return recs.filter(function(p){return handles.indexOf(p.handle)===-1;});
    })
    .catch(function(){return[];});
}

function recCardHTML(p){
  var variant=p.variants&&p.variants[0];
  var variantId=variant?variant.id:null;
  var price=variant?'Rs. '+(variant.price/100).toLocaleString('en-IN',{maximumFractionDigits:0}):'';
  var imgSrc=getImgSrc(p.featured_image);
  if(!imgSrc&&p.images&&p.images.length)imgSrc=getImgSrc(p.images[0]);
  var multi=p.variants&&p.variants.length>1;
  var cnt=getCount(p.handle);
  return '<div class="wl-rec-card">'
    +'<a href="/products/'+p.handle+'" class="wl-rec-card__img-wrap">'
    +(imgSrc?'<img src="'+imgSrc+'" alt="'+p.title+'" loading="lazy">':'<div class="wl-rec-card__img-placeholder"></div>')
    +'<span class="wl-rec-card__count"><svg viewBox="0 0 24 24" fill="#e03d2f" width="8" height="8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> '+cnt+'</span>'
    +'</a>'
    +'<div class="wl-rec-card__info">'
    +'<a href="/products/'+p.handle+'" class="wl-rec-card__title">'+p.title+'</a>'
    +'<span class="wl-rec-card__price">'+price+'</span>'
    +'</div>'
    +(multi
      ?'<a href="/products/'+p.handle+'" class="wl-rec-card__atc wl-rec-card__atc--options">Options</a>'
      :'<button class="wl-rec-card__atc" data-variant-id="'+variantId+'">Add to Cart</button>')
    +'</div>';
}

function bindRecATCs(container){
  container.querySelectorAll('.wl-rec-card__atc[data-variant-id]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      addToCart(btn.dataset.variantId,btn);
    });
  });
}

var _autoCloseTimer=null;

var WishlistDrawer={
  drawer:null, overlay:null,
  init:function(){
    this.drawer=document.getElementById('wishlist-drawer');
    this.overlay=document.getElementById('wishlist-overlay');
    if(!this.drawer)return;
    var self=this;
    this.overlay&&this.overlay.addEventListener('click',function(){self.close();});
    var cb=this.drawer.querySelector('.wishlist-drawer__close');
    cb&&cb.addEventListener('click',function(){self.close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')self.close();});
    /* Pause auto-close on mouse/touch interaction with the drawer */
    this.drawer.addEventListener('mouseenter',function(){if(_autoCloseTimer){clearTimeout(_autoCloseTimer);_autoCloseTimer=null;}});
    this.drawer.addEventListener('mouseleave',function(){self._startAutoClose();});
    this.drawer.addEventListener('touchstart',function(){if(_autoCloseTimer){clearTimeout(_autoCloseTimer);_autoCloseTimer=null;}},{passive:true});
    document.querySelectorAll('[data-open-wishlist]').forEach(function(el){
      el.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();self.open();});
    });
  },
  _startAutoClose:function(){
    var self=this;
    if(_autoCloseTimer)clearTimeout(_autoCloseTimer);
    _autoCloseTimer=setTimeout(function(){self.close();_autoCloseTimer=null;},4000);
  },
  open:function(){
    this.render();
    this.drawer.classList.add('is-open');
    this.overlay&&this.overlay.classList.add('is-visible');
    document.body.style.overflow='hidden';
    this._startAutoClose();
  },
  close:function(){
    if(_autoCloseTimer){clearTimeout(_autoCloseTimer);_autoCloseTimer=null;}
    this.drawer.classList.remove('is-open');
    this.overlay&&this.overlay.classList.remove('is-visible');
    document.body.style.overflow='';
  },
  render:function(){
    var list=getList();
    var body=this.drawer.querySelector('.wishlist-drawer__body');
    if(!body)return;
    var countEl=this.drawer.querySelector('.wishlist-drawer__count');
    if(countEl)countEl.textContent=list.length?'('+list.length+')':'';
    if(list.length===0){
      body.innerHTML='<div class="wishlist-drawer__empty">'
        +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">'
        +'<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>'
        +'</svg><p>Your wishlist is empty</p>'
        +'<small>Tap &#9825; on any product to save it here</small>'
        +'</div>';
      return;
    }
    body.innerHTML='<div class="wl-loading">Loading…</div>';
    Promise.all(list.map(function(handle){
      return fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(products){
      var valid=products.filter(Boolean);
      if(!valid.length){
        body.innerHTML='<div class="wishlist-drawer__empty"><p>Could not load items.</p></div>';
        return;
      }
      var ul=document.createElement('ul');
      ul.className='wishlist-items';
      valid.forEach(function(p){
        var li=document.createElement('li');
        li.className='wishlist-item';
        var variant=p.variants[0];
        var price='Rs. '+(variant.price/100).toLocaleString('en-IN',{maximumFractionDigits:0});
        var imgSrc=getImgSrc(p.featured_image);
        var multi=p.variants.length>1;
        var cnt=getCount(p.handle);
        li.innerHTML=
          '<a href="/products/'+p.handle+'" class="wishlist-item__img-link">'
          +(imgSrc?'<img src="'+imgSrc+'" alt="'+p.title+'" class="wishlist-item__image" loading="lazy">':'<div class="wishlist-item__image"></div>')
          +'</a>'
          +'<div class="wishlist-item__info">'
          +'<a href="/products/'+p.handle+'" class="wishlist-item__title">'+p.title+'</a>'
          +'<div class="wl-item-meta">'
          +'<span class="wishlist-item__price">'+price+'</span>'
          +'<span class="wl-item-count"><svg viewBox="0 0 24 24" fill="#e03d2f" width="10" height="10"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> '+cnt+' wishlisted</span>'
          +'</div>'
          +(multi
            ?'<a href="/products/'+p.handle+'" class="wishlist-item__atc">Choose Options</a>'
            :'<button class="wishlist-item__atc" data-variant-id="'+variant.id+'">Add to Cart</button>')
          +'</div>'
          +'<button class="wishlist-item__remove" data-handle="'+p.handle+'" aria-label="Remove">'
          +'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">'
          +'<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>'
          +'</svg></button>';
        var atcBtn=li.querySelector('.wishlist-item__atc[data-variant-id]');
        if(atcBtn)atcBtn.addEventListener('click',function(){addToCart(atcBtn.dataset.variantId,atcBtn);});
        var rmBtn=li.querySelector('.wishlist-item__remove');
        if(rmBtn)rmBtn.addEventListener('click',function(){
          var h=rmBtn.dataset.handle;
          saveList(getList().filter(function(x){return x!==h;}));
          document.querySelectorAll('[data-wl-btn][data-handle="'+h+'"]').forEach(syncBtn);
          syncCardBadge(h);
          WishlistDrawer.render();
        });
        ul.appendChild(li);
      });
      var items=Array.from(ul.querySelectorAll('li.wishlist-item'));
      items.sort(function(a,b){
        var ha=a.querySelector('.wishlist-item__remove').dataset.handle;
        var hb=b.querySelector('.wishlist-item__remove').dataset.handle;
        return getCount(hb)-getCount(ha);
      });
      ul.innerHTML='';
      items.forEach(function(i){ul.appendChild(i);});
      ul.querySelectorAll('.wishlist-item__atc[data-variant-id]').forEach(function(btn){
        btn.addEventListener('click',function(){addToCart(btn.dataset.variantId,btn);});
      });
      ul.querySelectorAll('.wishlist-item__remove').forEach(function(rmBtn){
        rmBtn.addEventListener('click',function(){
          var h=rmBtn.dataset.handle;
          saveList(getList().filter(function(x){return x!==h;}));
          document.querySelectorAll('[data-wl-btn][data-handle="'+h+'"]').forEach(syncBtn);
          syncCardBadge(h);
          WishlistDrawer.render();
        });
      });
      var recsSection=document.createElement('div');
      recsSection.className='wl-recs-section';
      recsSection.innerHTML=
        '<div class="wl-recs-header"><p class="wl-recs-title">You may also like</p></div>'
        +'<div class="wl-recs-scroll"><div class="wl-recs-track wl-recs-loading"><span>Finding recommendations…</span></div></div>';
      body.innerHTML='';
      body.appendChild(ul);
      body.appendChild(recsSection);
      var ids=valid.map(function(p){return p.id;});
      fetchAllRecs(ids).then(function(recs){
        var track=recsSection.querySelector('.wl-recs-track');
        if(!track)return;
        if(!recs||!recs.length){recsSection.style.display='none';return;}
        track.classList.remove('wl-recs-loading');
        track.innerHTML=recs.map(recCardHTML).join('');
        bindRecATCs(track);
      });
    });
  }
};

function boot(){
  syncAllButtons();
  syncAllBadges();
  updateHeaderCount();
  WishlistDrawer.init();
  if(window.MutationObserver){
    var syncing=false;
    var observer=new MutationObserver(function(mutations){
      if(syncing)return;
      var hasNew=mutations.some(function(m){
        return Array.from(m.addedNodes).some(function(n){
          return n.nodeType===1&&(n.matches('product-card')||n.querySelector('product-card'));
        });
      });
      if(!hasNew)return;
      syncing=true; syncAllButtons(); syncAllBadges(); syncing=false;
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
window.WishlistDrawer=WishlistDrawer;
window.WishlistAPI={getList:getList,toggle:toggle,isWishlisted:isWishlisted,getCount:getCount};
})();
